module.exports = __webpack_public_path__ + "static/media/dolce&gabanna.cadb9a6e.jpg";